import { render } from "./TokenBlock.vue?vue&type=template&id=d2e7ff96"
import script from "./TokenBlock.vue?vue&type=script&lang=js"
export * from "./TokenBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__